import { useEffect, useRef, useState } from 'react';
import iconFaq from '../assets/icon_faq.svg';
import iconPlus from '../assets/icon_plus.svg';
import { FAQS } from '../campaign';

/* Animated collapse: height 0 ↔ scrollHeight, settling on `auto` when open. */
function useCollapse(open, settleMs) {
  const ref = useRef(null);
  const first = useRef(true);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (first.current) {
      first.current = false;
      el.style.height = open ? 'auto' : '0px';
      return undefined;
    }
    let timer;
    if (open) {
      el.style.height = el.scrollHeight + 'px';
      timer = setTimeout(() => { el.style.height = 'auto'; }, settleMs);
    } else {
      el.style.height = el.scrollHeight + 'px';
      requestAnimationFrame(() => { el.style.height = '0px'; });
    }
    return () => clearTimeout(timer);
  }, [open, settleMs]);
  return ref;
}

function FaqItem({ q, a, open, onToggle }) {
  const bodyRef = useCollapse(open, 350);
  return (
    <div className={'bbd-faq-item' + (open ? ' bbd-open' : '')}>
      <button type="button" className="bbd-faq-q" onClick={onToggle} aria-expanded={open}>
        <span>{q}</span>
        <span className="bbd-chev">
          <svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6" /></svg>
        </span>
      </button>
      <div className="bbd-faq-a" ref={bodyRef}>
        <p>{a}</p>
      </div>
    </div>
  );
}

/* FAQs (expands into an accordion). */
export default function FaqSection() {
  const [faqOpen, setFaqOpen] = useState(false);
  const [openIdx, setOpenIdx] = useState(-1);
  const faqRef = useCollapse(faqOpen, 400);

  return (
    <section className="bbd-links">
      <div className="bbd-link-item">
        <button type="button" className="bbd-link-row" onClick={() => setFaqOpen(!faqOpen)} aria-expanded={faqOpen}>
          <span className="bbd-link-ic bbd-link-ic-faq"><img src={iconFaq} alt="" /></span>
          <span className="bbd-link-label">FAQs</span>
          <span className={'bbd-link-plus' + (faqOpen ? ' bbd-open' : '')}><img src={iconPlus} alt="" /></span>
        </button>
        <div className="bbd-link-body" ref={faqRef}>
          <div className="bbd-link-inner">
            {FAQS.map((f, i) => (
              <FaqItem
                key={f.q}
                q={f.q}
                a={f.a}
                open={openIdx === i}
                onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
